import {
  GET_EXPORTED_FILE,
  GET_EXPORTED_FILE_TEMPLATE,
  GET_EXPORTED_CUSTOMER_IMPORT_TEMPLATE,
  GET_EXPORTED_CUSTOMER_EXPORT_TEMPLATE,
} from './constants';

/**
 * Export file
 * @param {string} filename prefix to be matched against
 * @param {int} outletId current outlet id export
 * @param {string} currentPage name of current page that will be displayed when export fails
 * @return {{type, payload: {filename: *, outletId: *, currentPage: *}}}
 */
export function getExportedFile(filename, outletId, currentPage) {
  return {
    type: GET_EXPORTED_FILE,
    payload: { filename, outletId, currentPage },
  };
}

export function getExportedWithoutOutlet(filename) {
  return { type: GET_EXPORTED_FILE_TEMPLATE, payload: { filename } };
}

export function getExportedCustomerImportTemplate(fileId) {
  return { type: GET_EXPORTED_CUSTOMER_IMPORT_TEMPLATE, payload: { fileId } };
}

export function getExportedCustomerExportTemplate(fileId) {
  return { type: GET_EXPORTED_CUSTOMER_EXPORT_TEMPLATE, payload: { fileId } };
}
